module.exports = __webpack_public_path__ + "img/bank-transition.png";


//////////////////
// WEBPACK FOOTER
// ./static/bank-transition.png
// module id = 2736
// module chunks = 38